import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import DerivedFieldsBuilder from './collection/derived-field/DerivedFieldsBuilder';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { DERIVED_FIELD } from 'drapcode-constant';
export class DerivedFields extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectDetailCollections({ projectId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, match, actions, common, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionDetailPending,
      addUtilityFunctionToCollectionPending,
      selectedCollection,
      deleteUitilityFunctionPending,
      projectCollections,
      items,
      projectDetail,
      permissionFlags,
      plugins,
    } = collections;
    const { updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <CommonPageComponent parentClassName="">
        <CollectionHeaderNav
          label={types.DERIVED_FIELD}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionDetailPending && (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        )}
        {selectedCollection && (
          <DerivedFieldsBuilder
            actions={actions}
            commonActions={commonActions}
            projectId={projectId}
            version={version}
            utilities={selectedCollection.utilities}
            collection={selectedCollection}
            showDerivedFieldCreateLoader={addUtilityFunctionToCollectionPending}
            showUtilityDeleteLoader={deleteUitilityFunctionPending}
            collections={projectCollections}
            projectDetail={projectDetail}
            refCollectionItems={items}
            deleteFlag={permissionsArray.includes(DERIVED_FIELD)}
            plugins={plugins}
            updatedCollections={updatedCollections}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DerivedFields);
